export class SuccessController {

  session;

  constructor(parent) {
    this.session = parent;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/modals/success.ts
 **/